'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002497 from "./presto.types$$anon$97.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$96() {
  this.c3u = null;
  this.c3m = null;
  this.c3n = false;
  this.c3v = null;
  this.c3w = false;
  this.c3z = null;
  this.c3s = null;
  this.c3t = false;
  this.c3o = null;
  this.c3p = false;
  this.c3q = null;
  this.c3r = false;
  this.c3x = false;
  this.c3y = false;
  this.c3u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c3z = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$96 as $c_Lpresto_types$$anon$96 };
$p = $c_Lpresto_types$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$96;
/** @constructor */
function $h_Lpresto_types$$anon$96() {
}
export { $h_Lpresto_types$$anon$96 as $h_Lpresto_types$$anon$96 };
$h_Lpresto_types$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.c3u;
});
$p.L = (function() {
  if ((!this.c3n)) {
    this.c3m = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c3n = true;
  }
  return this.c3m;
});
$p.O = (function() {
  if ((!this.c3w)) {
    this.c3v = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c3w = true;
  }
  return this.c3v;
});
$p.E = (function() {
  return this.c3z;
});
$p.t = (function() {
  if ((!this.c3t)) {
    this.c3s = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3t = true;
  }
  return this.c3s;
});
$p.M = (function() {
  if ((!this.c3p)) {
    this.c3o = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3p = true;
  }
  return this.c3o;
});
$p.Q = (function() {
  if ((!this.c3r)) {
    this.c3q = new $j_presto$002etypes$0024$0024anon$002497.$c_Lpresto_types$$anon$97();
    this.c3r = true;
  }
  return this.c3q;
});
$p.w = (function() {
  if ((!this.c3y)) {
    this.c3x = false;
    this.c3y = true;
  }
  return this.c3x;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee127) => ((p) => \u03b4scrutinee127.cru(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$96, "presto.types$$anon$96", ({
  Yk: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$96 as $d_Lpresto_types$$anon$96 };
//# sourceMappingURL=presto.types$$anon$96.js.map
